var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columnss"},_vm._l((_vm.categorien),function(cat){return _c('Categorie',{key:cat.id,attrs:{"cat":cat,"cart":_vm.cart,"search":_vm.search},on:{"changed":_vm.ChangedAantal}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }